module.exports = __webpack_public_path__ + "img/home-delivery.d7b9632c.webp";